import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const StyledSectionColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '640px',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));
